// extracted by mini-css-extract-plugin
export default {"table":"UfoInnerTable_table__Zxhgc","row":"UfoInnerTable_row__UUcne"};